// インドの森: 送料無料プログレスバー（カートドロワー内）
// 2026-04-28 追加。Shopify国内配送設定（国内配送ゾーン）と一致
(function () {
  // このバーの送料表・無料ライン3,251gはすべて日本ゾーンの設定値。
  // 送料無料が存在するのは104ゾーン中26のみで、日本以外の市場に出すと
  // 事実と異なる訴求になるため、配送先が日本のときだけ描画する。
  // Shopify.country は content_for_header が defer スクリプトより先に同期定義し、
  // 市場切替（/localization）にも追従することを実測済み。
  // 判定できないときは「出さない」側に倒す（事実と異なる訴求の防止がこのゲートの目的）。
  if (!window.Shopify || window.Shopify.country !== 'JP') return;

  const THRESHOLD_GRAMS = 3251;
  const WEIGHT_LIMIT = 5000; // 1回のご注文は総重量5kgまで（利用規約）。超過はレート無し＝決済不可

  // 国内配送（日本）の重量別送料テーブル（Shopify shipping_zones と同期）
  // [上限グラム, 円] — 上から順に判定
  // ⚠ この3定数は snippets/inm-delivery-estimate.liquid の INM-DATA（JP行・
  //    inm_ship_free_from の JP・inm_ship_max_g）の手書き複製。料率改定時は
  //    scripts/gen_shipping_snippet.py の再生成に加えてここも直すこと
  //    （同スクリプトが起動時に両者の一致を検査して警告する）。
  const DOMESTIC_RATES = [
    [250, 2800],
    [500, 2600],
    [750, 2400],
    [1000, 2200],
    [1250, 1900],
    [1500, 1700],
    [1750, 1500],
    [2000, 1300],
    [2250, 1100],
    [2500, 800],
    [2750, 600],
    [3000, 400],
    [3250, 200],
    [5000, 0],
  ];

  function estimateShipping(weight) {
    if (weight <= 0) return null;
    for (let i = 0; i < DOMESTIC_RATES.length; i++) {
      if (weight <= DOMESTIC_RATES[i][0]) return DOMESTIC_RATES[i][1];
    }
    // 5kg超はレート自体が存在しない＝決済不可。「無料」と偽らない
    return null;
  }

  function fmtJpy(n) {
    return '¥' + n.toLocaleString('ja-JP');
  }

  function fmtKg(g, digits) {
    if (digits === undefined) digits = 2;
    return (g / 1000).toFixed(digits) + 'kg';
  }

  // 「あと◯kg」の残量表示専用: 小数第2位で切り上げる。
  // toFixed（最近接丸め）だと必要量より少ない値を提示してしまう
  // （例: 残751g→「あと0.75kg」だが750g追加では¥200課金、境界では「あと0.00kg」）。
  // 切り上げなら提示量を足せば必ず無料ラインに届く。
  function fmtKgUp(g) {
    return (Math.ceil(g / 10) / 100).toFixed(2) + 'kg';
  }

  function buildBar(weight) {
    const remaining = Math.max(0, THRESHOLD_GRAMS - weight);
    const pct = Math.min(100, Math.round((weight / THRESHOLD_GRAMS) * 100));
    const qualified = weight >= THRESHOLD_GRAMS;
    const msg = weight > WEIGHT_LIMIT
      ? '<span class="over-limit">⚠ 5kgを超えています。1回のご注文は総重量5kgまでです。</span>'
      : qualified
      ? '<span class="qualified">✓ 送料無料の対象です！</span>'
      : 'あと <strong>' + fmtKgUp(remaining) + '</strong> で日本全国送料無料！';
    const shipping = estimateShipping(weight);
    const shippingLabel =
      shipping === null
        ? '—'
        : shipping === 0
        ? '<span class="qualified">無料</span>'
        : fmtJpy(shipping);
    const weightLine =
      '<p class="free-shipping-progress__weight">現在のカート重量：<strong>' +
      fmtKg(weight) +
      '</strong> <span class="free-shipping-progress__threshold">／ 無料ライン ' +
      fmtKg(THRESHOLD_GRAMS, 3) +
      '</span></p>' +
      '<p class="free-shipping-progress__shipping">' +
      '日本国内 送料目安：<strong>' + shippingLabel + '</strong>' +
      '</p>';
    return (
      '<div class="free-shipping-progress" data-qualified="' + qualified + '">' +
      '<p class="free-shipping-progress__msg">' + msg + '</p>' +
      weightLine +
      '<div class="free-shipping-progress__bar">' +
      '<div class="free-shipping-progress__fill" style="width:' + pct + '%"></div>' +
      '</div></div>'
    );
  }

  function updateBars(weight) {
    document.querySelectorAll('.free-shipping-progress-mount').forEach(function (host) {
      host.innerHTML = buildBar(weight);
    });
  }

  function clearBars() {
    document.querySelectorAll('.free-shipping-progress-mount').forEach(function (host) {
      host.innerHTML = '';
    });
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        ensureMountPoints();
        var items = cart.item_count || 0;
        var weight = cart.total_weight || 0;
        // 商品はあるのに重量0g＝国内倉庫発送の送料込み商品か配送のない役務だけ。
        // 重量制の送料表は無関係なので「あと◯kgで送料無料」を出さない（【送料無料】商品で矛盾するため）。
        if (items > 0 && weight === 0) { clearBars(); return; }
        updateBars(weight);
      })
      .catch(function () {});
  }

  function ensureMountPoints() {
    // Cart drawer: single mount inside cart-drawer (only one)
    const drawer = document.querySelector('cart-drawer');
    if (drawer && !drawer.querySelector('.free-shipping-progress-mount')) {
      const target = drawer.querySelector('.cart-drawer__form, .drawer__contents, .drawer__inner') || drawer;
      const mount = document.createElement('div');
      mount.className = 'free-shipping-progress-mount';
      target.prepend(mount);
    }
    // Cart page: above cart items
    const cartItems = document.querySelector('main cart-items, main #main-cart-items');
    if (cartItems && !cartItems.parentNode.querySelector('.free-shipping-progress-mount')) {
      const mount = document.createElement('div');
      mount.className = 'free-shipping-progress-mount';
      cartItems.parentNode.insertBefore(mount, cartItems);
    }
  }

  // Initial render
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchCartAndUpdate);
  } else {
    fetchCartAndUpdate();
  }

  // Re-render on cart updates (Shopify dispatches these in modern themes)
  document.addEventListener('cart:updated', fetchCartAndUpdate);
  document.addEventListener('cart-drawer:open', fetchCartAndUpdate);

  // Hook ajax cart adds: Shopify themes often POST to /cart/add.js
  const _fetch = window.fetch;
  window.fetch = function () {
    const result = _fetch.apply(this, arguments);
    try {
      const url = String(arguments[0] || '');
      if (url.indexOf('/cart/') !== -1) {
        result.then(function () { setTimeout(fetchCartAndUpdate, 200); });
      }
    } catch (e) {}
    return result;
  };
})();
